import { CapoPlugin } from "/Users/guilherme/www/ntask/financeiro/financeiro-front/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];